import React from 'react';
import ReactDOM from 'react-dom';

// build time (node context) does not have document defined.
const modal = typeof document !== 'undefined' ? document.getElementById('global-modal') : null;

const Modal = 'rcm-user-switch-modal' as React.ElementType;

export const RcmUserSwitchModal = (): JSX.Element => {
  return modal ? ReactDOM.createPortal(<Modal />, modal) : null;
};
